import { createSlice } from "@reduxjs/toolkit";
const getInitialPhi = () => {
  const stored = localStorage.getItem("phi");
  if (stored === "true") return true;
  if (stored === "false") return false;
  return false;
};

const getInitialCgPlus = () => {
  const stored = localStorage.getItem("cgPlus");
  if (stored === "true") return true;
  if (stored === "false") return false;
  return false;
};

const initialState = {
  phi: getInitialPhi(),
  cgPlus: getInitialCgPlus(),
};

const togglesSlice = createSlice({
  name: "toggles",
  initialState,
  reducers: {
    togglePhi: (state) => {
      state.phi = !state.phi;
      localStorage.setItem("phi", state.phi);
    },
    setPhi: (state, action) => {
      state.phi = action.payload;
      localStorage.setItem("phi", state.phi);
    },
    toggleCgPlus: (state) => {
      state.cgPlus = !state.cgPlus;
      localStorage.setItem("cgPlus", state.cgPlus);
    },
    setCgPlus: (state, action) => {
      state.cgPlus = action.payload;
      localStorage.setItem("cgPlus", state.cgPlus);
    },
  },
});

export const { togglePhi, setPhi, toggleCgPlus, setCgPlus } = togglesSlice.actions;
export default togglesSlice.reducer;
